export enum TradeDataPublicSearchBy {
  COMPANY_BUYER = "company_buyer",
  COMPANY_SUPPLIER = "company_supplier"
}